import React from 'react';

import type {EntityPageCoverImageQueryResult } from './CoverImageQuery.gql-types';

import { Helmet } from 'react-helmet-async';

type PreloadCoverProps = {
  queryResult: EntityPageCoverImageQueryResult
};

export const PreloadCover = ({ queryResult }: PreloadCoverProps) => {
  const coverImageList = queryResult?.data?.entityPageEX?.__typename === "EntityPage" ? queryResult?.data.entityPageEX?.coverImage : undefined;
  if (coverImageList?.[0]?.url && coverImageList?.[1]?.url) {
    return (
      <Helmet>
        <link
          rel="preload"
          href={coverImageList[0].url}
          as="image"
          media="(max-width: 600px)"
        />
        <link
          rel="preload"
          href={coverImageList[1].url}
          as="image"
          media="(min-width: 601px)"
        />
      </Helmet>
    );
  }

  return null;
};

